/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  Reducer for sweetDeal module
 */

import { falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { CurrentSearch } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleAction, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  DONE_FETCHING_SWEET_DEALS,
  ERROR_FETCHING_SWEET_DEALS,
  RECEIVE_SWEET_DEALS,
  START_FETCHING_SWEET_DEALS,
} from '../constants'

type Actions = ExtractActions<Values<typeof actions>>

export const sweetDealsAllowedList = [
  DONE_FETCHING_SWEET_DEALS,
  ERROR_FETCHING_SWEET_DEALS,
  RECEIVE_SWEET_DEALS,
  START_FETCHING_SWEET_DEALS,
] as const satisfies ReadonlyArray<Actions['type']>

declare const shouldBeEmpty: Exclude<Actions['type'], (typeof sweetDealsAllowedList)[number]>
false && (shouldBeEmpty satisfies never)

export const sweetDealsReducer = combineReducers<CurrentSearch['sweetDeals'], Actions>({
  fetching: handleActions(
    {
      [START_FETCHING_SWEET_DEALS]: trueReducer,
      [DONE_FETCHING_SWEET_DEALS]: falseReducer,
      [ERROR_FETCHING_SWEET_DEALS]: falseReducer,
    },
    false
  ),
  data: handleAction<CurrentSearch['sweetDeals']['data'], Actions, typeof RECEIVE_SWEET_DEALS>(
    RECEIVE_SWEET_DEALS,
    payloadReducer,
    null
  ),
})
